module.exports = __webpack_public_path__ + "img/xray-trace.30a62589.jpg";